import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Receivable } from 'services/action';

import { Page, Button } from 'ui/components';
import { FormGeneral, FormProduct, FormNote, FormSubtotal } from './component/form';

const initialState = {
  data: null,
  general: null,
  products: null,
  note: null,
  payment: null,
  isLoading: true,
};

const UpdateScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();

  const StateForm = useSelector((state) => state?.Form);
  const isLoading = useSelector(
    (state) => state?.Activity?.services['Receivable.Show']
  );

   const [{ general, products, note, payment, data }, setState] =
    React.useState(initialState);

  const $onLoad = async (e) => {
    const req = await Dispatch(Receivable.$show(e, {load_down_payment: true}));

    if (req?.message === 'success') {
      setState((prevState) => ({
        ...prevState,
        data: req?.data,
      }));
    }
  };

  const $handleSubmit = async (e) => {
    const payload = {
      customer_id: general?.customer?.id,
      project_id: general?.project?.id,
      term_of_payment: general?.term_of_payment?.value || 0,
      periode_project_at: general?.periode_project_at?.formatted,
      schedule_at: general?.schedule_at?.formatted,
      due_at: general?.due_at?.formatted,
      billing_address: general?.billing_address,
      emails: general?.emails,
      ...note,
      discount: payment?.discount || 0,
      pph: payment?.pph,
      down_payment: payment?.down_payment,
      products
    };

    const req = await Dispatch(Receivable.$update(data?.id, payload));

    if (req?.message === 'success') {
      History?.push(`/receivable/${req?.data?.id}`);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page type="form" onSubmit={$handleSubmit} className="detail-fixed">
      <Page.Header title="Perbaharui Invoice" className="bg-light" />

      <Page.Body className="d-block row px-3">
        <FormGeneral
          data={data}
          onChange={(e) =>
            setState((prevState) => ({ ...prevState, general: e }))
          }
          isLoading={isLoading}
        />
        <FormProduct
          data={data?.products}
          onChange={(e) =>
            setState((prevState) => ({ ...prevState, products: e }))
          }
          project={general?.project}
          isLoading={isLoading}
        />

        <div className='row'>
          <div className='col-6'>
            <FormNote
              data={data}
              onChange={(e) =>
                setState((prevState) => ({ ...prevState, note: e }))
              }
              isLoading={isLoading}
            />
          </div>
          <div className='col-6'>
            <FormSubtotal
              data={data}
              onChange={(e) =>
                setState((prevState) => ({ ...prevState, payment: e }))
              }
              products={products}
              isLoading={isLoading}
              project={general?.project}
            />
          </div>
        </div>
      </Page.Body>
      <Page.Footer className="bg-light justify-content-center gap-md-2 pt-2 pb-0 pb-md-3 mb-2 mb-md-0 border-top d-md-flex d-block flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/receivable`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default UpdateScreen;
